<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ChooseCenter />
	</DaModalFrame>
	<div
		class="___default relative"
		:class="
			sideActive && !setup.store.state.sideBarisHide ? 'side--active' : ''
		"
	>
		<div
			class="background fixed"
			v-if="sideActive"
			v-show="!setup.store.state.sideBarisHide"
			@click="setActive(false)"
		></div>
		<div
			class="draw-icon fixed"
			@click="setActive(!sideActive)"
			v-if="!setup.store.state.sideBarisHide"
		>
			<svg
				:class="{ 'rotate-180': sideActive }"
				class="transform h-4"
				width="9"
				height="17"
				viewBox="0 0 9 17"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.293278 15.7853C0.0270118 15.5191 0.00280571 15.1024 0.22066 14.8088L0.293278 14.7247L6.76261 8.255L0.293278 1.78533C0.0270118 1.51906 0.00280571 1.1024 0.22066 0.808785L0.293278 0.724668C0.559545 0.458401 0.976209 0.434195 1.26982 0.652049L1.35394 0.724668L8.35394 7.72467C8.6202 7.99093 8.64441 8.4076 8.42656 8.70121L8.35394 8.78533L1.35394 15.7853C1.06105 16.0782 0.586172 16.0782 0.293278 15.7853Z"
					fill="#707070"
				/>
			</svg>
		</div>
		<div
			v-show="!setup.store.state.sideBarisHide"
			class="___default__side-menu bg-white h-screen fixed top-0 left-0 flex flex-col justify-between items-start border-r border-neutral-100"
		>
			<SideMenu @logout="logout" @choose="openModal" />
			<div class="p-4 px-6">
				<img
					src="../../assets/images/logo/luca.svg"
					alt="luca-education"
					title="Luca Education"
					class="logo"
					height="50"
				/>
				<div class="text-sm text-neutral-500 font-medium pl-1">
					{{ version }}
				</div>
			</div>
		</div>
		<div
			class="___default__content"
			:class="{ 'side-bar-hide': setup.store.state.sideBarisHide }"
		>
			<slot></slot>
		</div>
		<div
			class="tutorial-dock fixed flex items-center gap-3"
			:class="{ 'tutorial-dock--offset': showTutorialShortcut }"
		>
			<Bubble
				v-if="isShowBubble && flagCheck && !isLucaAiHidden"
				@close="isShowBubble = false"
			/>
		</div>
	</div>
</template>
<script>
import { Options, Vue, setup } from 'vue-class-component';
import SideMenu from '@/components/layouts/sideMenu/SideMenu.vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { useStore } from 'vuex';
import { _ROUTER_NAME } from '@/enums';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ChooseCenter from '@/components/elements/chooseCenter/ChooseCenter.vue';
import { Watch } from 'vue-property-decorator';
import Bubble from '@/views/lucaAIChat/Bubble.vue';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { computed } from 'vue';
import { useTutorial } from '@/features/tutorial/useTutorial';
@Options({
	name: 'DefaultLayout',
	components: {
		ChooseCenter,
		DaModalFrame,
		DaIcon,
		SideMenu,
		Bubble,
	},
})
export default class DefaultLayout extends Vue {
	//----------------------- 🤍 Data 🤍 -----------------------//
	sideActive = true;
	isShowBubble = true;
	flagCheck = computed(() => FLAG_CHECK('LUCA_AI_CHAT'));
	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const store = useStore();
		return {
			store,
		};
	});

	mounted() {
		if(this.$route.name === _ROUTER_NAME.LUCA_AI_CHAT) {
			this.isShowBubble = false;
		}
		this.sideActive = window.screen.width >= 1024;

		window.addEventListener('resize', () => {
			this.sideActive = window.screen.width >= 1024;
		});
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	setActive(value) {
		this.sideActive = value;
	}

	modalIsOpen = false;

	openModal() {
		this.modalIsOpen = true;
	}

	logout() {
		localStorage.clear();
		this.$router.replace({ name: _ROUTER_NAME.LOGIN });
	}

	get isLucaAiHidden() {
		return useTutorial().isLucaAiHidden.value;
	}

	get showTutorialShortcut() {
		return useTutorial().isFabVisible.value;
	}

	@Watch('$route', { immediate: true, deep: true })
	onRouteChange(value) {
		if (
			value &&
			(value?.query?.action === 'edit' ||
				value?.query?.action === 'full-screen')
		) {
			this.setup.store.dispatch('setSideBar', true);
		} else {
			this.setup.store.dispatch('setSideBar', false);
		}
		if(value?.name === _ROUTER_NAME.LUCA_AI_CHAT) {
			this.isShowBubble = false;
		} else {
			this.isShowBubble = true;
		}
	}

	get version() {
		return process.env.VUE_APP_VERSION;
	}
}
</script>
<style lang="scss" scoped>
@import './src/assets/styles/responsive';

.___default {
	@include media-breakpoint-down(md) {
		.background {
			height: 100vh;
			width: 100vw;
			background: rgba(0, 0, 0, 0.2);
			z-index: 8;
		}
	}

	&__side-menu {
		width: 245px;
		transition: all 0.4s ease;
		overflow-y: auto;
		z-index: 9;
		transform: translateX(-100%);
		padding-right: 20px;

		&::-webkit-scrollbar {
			width: 0;
		}
	}

	.draw-icon {
		left: 245px;
		top: 24px;
		padding: 10px 6px;
		border-radius: 0 4px 4px 0;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		z-index: 9;
		@apply shadow bg-white border border-neutral-50 text-neutral-400 hover:text-blue-700;
	}

	&__content {
		transition: all 0.4s ease;
		padding-left: 0;
	}

	.draw-icon {
		display: flex;
		transition: all 0.4s ease;
		left: 0;
	}

	@include media-breakpoint-down(md) {
		&__side-menu {
			transform: translateX(-245px);
		}

		&__content {
			padding-left: 0 !important;
		}

		.draw-icon {
			left: 0;
		}
	}
}

.side--active {
	.draw-icon {
		transition: all 0.4s ease;
		left: 245px !important;
	}

	.___default__side-menu {
		transition: all 0.4s ease;
		transform: translateX(0) !important;
	}

	@include media-breakpoint-up(lg) {
		.___default__content {
			transition: all 0.4s ease;
			padding-left: 245px !important;
		}
	}
}

.__menu__item--open {
	background: #fef8ed !important;
	color: #d89210 !important;
}

::v-deep {
	.router-link-exact-active {
		.__menu__sub,
		.__menu__item,
		.tab {
			background: #fef8ed !important;
			color: #d89210 !important;
			border-right: 2px solid #f0bb4f;
		}
	}

	.router-link-active {
		.__menu__sub,
		.__menu__item {
			background: #fef8ed !important;
			color: #d89210 !important;
			border-right: 2px solid #f0bb4f;
		}
	}
}

.logo {
	height: 80px;
	width: auto;
	margin-top: 30px;
}

.tutorial-dock {
	right: 24px;
	bottom: 24px;
	z-index: 40;
}

.tutorial-dock--offset {
	right: 88px;
}

.side-bar-hide {
	@include media-breakpoint-up(lg) {
		padding-left: 0 !important;
	}
}
</style>
